// extracted by mini-css-extract-plugin
module.exports = {"container":"primaryNavigation_container__eacNl"};